// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-nav__accordions[data-v-2a249380]{margin:0 0 15px}", ""]);
// Exports
module.exports = exports;
